export function shouldUseAppConfigForEnvironment(appConfigEnvironent: string) {
  return !!(appConfigEnvironent === 'test' || appConfigEnvironent === 'prod' || appConfigEnvironent === 'dev');
}
